module.exports = __webpack_public_path__ + "static/media/mega645.f8dce807.png";